module.exports = __webpack_public_path__ + "static/media/NationalBankGreyLogo.223552dd.png";